export const RumFeature = {
    AutoApply: 'auto-apply',
    AutoApplySetup: 'auto-apply-setup',
} as const;

export const REDACTED_RUM_FEATURES = new Set<string>(Object.values(RumFeature));

export interface RumFeatureErrorContext {
    feature: string;
    page?: unknown;
    action?: unknown;
    operation?: unknown;
    failureKind?: unknown;
}

export const getRumFeatureErrorMessage = ({
    feature,
    page,
    action,
    operation,
    failureKind,
}: RumFeatureErrorContext): string => {
    const safePage = typeof page === 'string' ? page : 'unknown-page';
    const safeAction = typeof action === 'string' ? action : 'unknown-action';
    const safeOperation =
        typeof operation === 'string' && operation !== safeAction ? ` ${operation}` : '';
    const safeFailureKind = typeof failureKind === 'string' ? ` ${failureKind}` : '';

    return `${feature} ${safePage} ${safeAction}${safeOperation}${safeFailureKind} error`;
};
